import Axios from 'axios'

export const trackEvent = async eventId => {
  try {
    await Axios.get(`/api/analytics/trackevent/${eventId}`)
    console.log('Successfully tracked event', eventId)
  } catch (error) {
    console.warn('Unable to track event', eventId, error)
  }
}

export const trackOutcome = async outcomeId => {
  try {
    await Axios.get(`/api/analytics/trackoutcome/${outcomeId}`)
    console.log('Successfully tracked outcome', outcomeId)
  } catch (error) {
    console.warn('Unable to track outcome', outcomeId, error)
  }
}

export const trackSearch = async (eventId, keyword) => {
  try {
    await Axios.get(`/api/analytics/tracksearch/${eventId}/${keyword}`)
    console.log('Successfully tracked search event', eventId, keyword)
  } catch (error) {
    console.warn('Unable to track search event', eventId, keyword, error)
  }
}
